import Vue from 'vue';
import Multiselect from 'vue-multiselect';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
Vue.use(Multiselect);
// eslint-disable-next-line vue/multi-word-component-names
Vue.component('Multiselect', Multiselect);
